import { gql } from "@apollo/client";

export const RESET_YOUR_PWD = gql`
  mutation resetYourPWD($email: String!, $emailOptions: emailOptionsInput!) {
      resetYourPWD(input: { email: $email, emailOptions: $emailOptions })
  }
`;
